import { render, staticRenderFns } from "./ReturnPlayers.vue?vue&type=template&id=1c96becf&scoped=true&"
import script from "./ReturnPlayers.vue?vue&type=script&lang=js&"
export * from "./ReturnPlayers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c96becf",
  null
  
)

export default component.exports